import { fetchPageAssets } from '../../ducks/hostedAssets.duck';

export const loadData = (params, search, config, preferredLanguage) => dispatch => {
  const pageId = params.pageId;
  const pageAsset = { [pageId]: `content/pages/${pageId}.json` };
  const hasFallbackContent = false;
  const language = preferredLanguage || config?.localization?.language;
  return dispatch(fetchPageAssets(pageAsset, hasFallbackContent, language));
};
